import api from "./client";

export const getRegions = () =>
  api.get("/api/regions/");

export const getDistricts = (regionId) =>
  api.get(`/api/districts/?region=${regionId}`);
